import * as Variations from './Variations'
import { HtmlBuilder } from './HtmlBuilder'
import { AccordionFactory } from '../../factories/AccordionFactory'
import { EditorComponentContract } from '../EditorComponentContract'
export class Accordion extends EditorComponentContract {
  constructor() {
    super(Variations)
    this.htmlBuilder = HtmlBuilder
    this.factory = new AccordionFactory
    this.innerComponent = false
  }

  elementIds() {
    return ['id', 'iconId', 'iconContainerId']
  }

  elementClasses() {
    return ['titleClasses', 'iconContainerClasses', 'classes']
  }

  elementStyles() {
    return [
      {id:'id', element: 'id', styles: 'styles', selector: '#', variation: null},
      {id:'iconId', element: 'id', styles: 'iconStyles', selector: '#', variation: null},
      {id:'iconContainerId', element: 'id', styles: 'iconContainerStyles', selector: '#', variation: null},
      {element: 'class', styles: 'titleStyles', selector: '.accordion-title', variation: null},
      {element: 'class', styles: 'activeTitleStyles', selector: '.accordion--active', variation: null},
      {element: 'class', styles: 'inactiveTitleStyles', selector: '.accordion--inactive', variation: null},
      {element: 'class', styles: 'activeChevronStyles', selector: '.accordion-chevron--active', variation: null},
      {element: 'class', styles: 'inactiveChevronStyles', selector: '.accordion-chevron--inactive', variation: null},
    ]
  }
  
  elementContents() {
    return ['hasIcon', 'class', 'icon', 'severalOpen']
  }

  info() {
    return {
      name: 'Accordion',
      icon: 'fa-minus-square',
      variations: this.variationsInfo()
    }
  }
}